export enum LogInStatus {
  success,
  Error,
  Timeout,
  No_connection,
  InvalidUser
}
